/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PromoTokenType {
    EXTERNALURL = 'EXTERNAL_URL',
    COUPONCODE = 'COUPON_CODE',
    QRCODE = 'QR_CODE'
}

export function PromoTokenTypeFromJSON(json: any): PromoTokenType {
    return PromoTokenTypeFromJSONTyped(json, false);
}

export function PromoTokenTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenType {
    return json as PromoTokenType;
}

export function PromoTokenTypeToJSON(value?: PromoTokenType | null): any {
    return value as any;
}

